import React from 'react';
import { Checkbox, Grid } from '@material-ui/core';
import FromServer from '../module/projects/FromServer';
import Utils from '../providers/Utils';
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'
import AlertDialog from '../commons/dialogs/AlertDialog'
import PropTypes from 'prop-types'


export default class SubTaskuriList extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
        elementeAfisate:this.props.listSubTaskuri || [],
        subTaskNou:this.props.dictionary.proiecte.etapeProiect.subTask,
        hideCalendar:false,
        hideCalendarFinish:false,
        dtDataStart: new Date(),
        dtDataFinish: new Date(),
        idSelectat:'',
        isOpenAlert:false

        }
    }




     componentDidMount(){
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.listSubTaskuri || [],
        })
    }


    changeStatusTask =(s,ev)=>{

        
                let fs = new FromServer()
        

                let cloneEl = [...this.state.elementeAfisate]
            let idx = this.state.elementeAfisate.findIndex(e => e.id === s.id)
        
        
            cloneEl[idx].statusul = ev.target.checked ? 'Finalizat' : 'In Lucru'
        
            let obj = {
                statusul:cloneEl[idx].statusul
            }
        
            let updateSubTask = fs.updateTask(obj, s.id)
        
            if(updateSubTask){
        
                this.setState({elementeAfisate:cloneEl})
                this.props.getData()
        
            }
        
        

            
    }

    subTaskChange=(s,ev)=>{

        if(this.props.isUserView ){

        }else{
        let fs = new FromServer()
           

            let cloneEl = [...this.state.elementeAfisate]
        let idx = this.state.elementeAfisate.findIndex(e => e.id === s.id)


        cloneEl[idx].titlu =ev.target.value


            this.setState({elementeAfisate:cloneEl})
        }
        

    }

    updateSubTask = async(s) =>{

        if(this.props.isUserView ){

        }else{
            let fs = new FromServer()

            let cloneEl = [...this.state.elementeAfisate]
            let idx = this.state.elementeAfisate.findIndex(e => e.id === s.id)

            let idUtilizator = this.props.objInfoTask.id_utilizator_responsabil
        

            let obj = {
                titlu:cloneEl[idx].titlu,
                id_etapa_proiect:this.props.objInfoTask.id_etapa_proiect,
                id_utilizator_responsabil:this.props.objInfoTask.id_utilizator_responsabil,
            }

            let updateSubTask =await fs.updateTask(obj, s.id)

            if(updateSubTask){
        
                this.setState({elementeAfisate:cloneEl})
                this.props.getData()
            }
        }
    }


    insertSubTask = async () =>{

        if(this.props.isUserView ){

        }else{
                let fs = new FromServer()

                let u = new Utils()

                let idTask = this.props.objInfoTask.id

                let idUtilizator = this.props.objInfoTask.id_utilizator_responsabil
            

                let objInsert = {
                    id_task_parent:idTask,
                    cand_data:this.props.objInfoTask.cand_data,
                    titlu:this.state.subTaskNou,
                    id_utilizator_responsabil:idUtilizator,
                    id_proiect:this.props.objInfoTask.id_proiect,
                    id_etapa_proiect:this.props.objInfoTask.id_etapa_proiect
                }


                let insert = await fs.insertTask(objInsert)


                if(insert){
                    this.setState({subTaskNou:this.props.dictionary.proiecte.etapeProiect.subTask},()=>{
                    
                        this.props.getData()
                    })
                }

            }
     


    }

    deleteEtapa = (s) =>{

        if(this.props.isUserView ){

                }else{
                let fs = new FromServer()

            


            

                let obj = {
                    inactiv:1
                }

                let updateSubTask = fs.updateTask(obj, s.id)

                if(updateSubTask){
            
                    this.props.getData()
            
                }
            }
    }


    showData = (d)=>{

        

        let u = new Utils()
        if(this.props.dictionary.data ==='en'){
            return u.dataPrescurtataEng(d)

        }else{
            return u.dataPrescurtataRomana(d)
        }
    }

    showCalendarStart = (s) =>{
        // console.log('calendar subtaskSelectat :', s);

        if(this.props.isUserView ){

        }else{
        let u  = new Utils();
        this.setState({
            hideCalendar:true,
            hideCalendarFinish:false,
            dtDataStart: s.cand_data !== null ?  new Date(u.ParseDataFromSql(s.cand_data)) : new Date(),
            idSelectat:s.id
        })
    }

    }

    showCalendarFinish = (s) =>{
        // console.log('calendar subtaskSelectat :', s);

        if(this.props.isUserView ){

        }else{
        let u  = new Utils();
        this.setState({
            hideCalendarFinish:true,
            hideCalendar:false,
            dtDataFinish: s.pana_cand_data !== null ?  new Date(u.ParseDataFromSql(s.pana_cand_data)) : new Date(),
            idSelectat:s.id
        })
    }

    }

    dataStartChange = (ev) =>{
        if(this.props.isUserView ){

        }else{
        let fs =new FromServer();

        let u = new Utils()

        // console.log('ev data start :', ev);

        let dataChanghed = ''

        if(this.props.dtDataStart <= ev && ev <= this.props.dtDataFinish ){
           

             let obj ={ 
                cand_data:u.transformDataForSql(ev)
            }
   
       
            // console.log('dataSTart :', this.props.dtDataStart);
   
            // console.log('dataFinish :', this.props.dtDataFinish);
   
   
            // console.log('obj :', obj);


             let update =  fs.updateTask(obj, this.state.idSelectat)

                if(update){

                

                        this.setState({
                            dtDataStart: ev,
                            hideCalendar:false 

                        },()=>{
                            this.props.getData()
                        })
                    
                }
        }else{
          

            this.setState({
                isOpenAlert:true
             },()=>{
                //  console.log('this.state.dtDataStart :', this.state.dtDataStart);
             })
        }  
    }  
}


dataFinishChange = (ev) =>{
    if(this.props.isUserView ){

    }else{
        let fs =new FromServer();

        let u = new Utils()

        // console.log('ev data start :', ev);

        let dataChanghed = ''

        if(this.props.dtDataStart <= ev && ev <= this.props.dtDataFinish ){
        

            let obj ={ 
                pana_cand_data:u.transformDataForSql(ev)
            }

    
            // console.log('dataSTart :', this.props.dtDataStart);

            // console.log('dataFinish :', this.props.dtDataFinish);


            // console.log('obj :', obj);


            let update =  fs.updateTask(obj, this.state.idSelectat)

                if(update){

                

                        this.setState({
                            dtDataFinish: ev,
                            hideCalendarFinish:false 

                        },()=>{
                            this.props.getData()
                        })
                    
                }
        }else{
        

            this.setState({
                isOpenAlert:true
            },()=>{
                // console.log('this.state.dtDataStart :', this.state.dtDataStart);
            })
        } 
    }   
}

     render() { 
       return (
          <div>
              <Grid container className='pm-insert-task-header'>
              {this.state.elementeAfisate.map((s,idx)=>{
                  return(
                      
                           <Grid key={idx} className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Checkbox style={{color:'#000000'}}  onChange={(ev)=>{this.changeStatusTask(s,ev)}} checked={s.statusul !== 'Finalizat' ? false : true}  />
                                <input style={{width:'70%'}} className='pm-task-description-input' type='text' value={s.titlu} onChange={(ev)=>{this.subTaskChange(s,ev)}}  onBlur={()=>{this.updateSubTask(s)}}/>
                              
                              
                              
                               <div className='pm-subtask-change-container' style={{width:'fit-content'}}>
                               <input type='text' value='' readOnly={true} style={{maxWidth:80}} className='pm-input-date-selector' onFocus={()=>{this.showCalendarStart(s)}}  />
                 <span   className="pm-task-date-selector">{s.cand_data !== null ? this.showData(s.cand_data) : this.props.dataStart } - </span>  
                 
                 
                 <input type='text' value='' readOnly={true} style={{maxWidth:80}} className='pm-input-date-selector'  onFocus={()=>{this.showCalendarFinish(s)}}  />
                 <span    className="pm-task-date-selector">{s.pana_cand_data !== null ? this.showData(s.pana_cand_data) : this.props.dataFinish }</span>
               

              

                 <Calendar
                        
                        className= {this.state.hideCalendar ? (this.state.idSelectat === s.id ?'pm-calendar-etape' : 'pm-hide-calendar'   ) : 'pm-hide-calendar' }
                        locale={this.props.dictionary.date}
                        onChange={(ev)=>{this.dataStartChange(ev)}}
                        value={this.state.dtDataStart}
                                            />
                                          
                  <Calendar
                        
                        className={this.state.hideCalendarFinish ? (this.state.idSelectat === s.id ?   'pm-calendar-etape pm-calendar-finish' : 'pm-hide-calendar-finish')   : 'pm-hide-calendar-finish'}
                        locale={this.props.dictionary.date}
                        onChange={(ev)=>{this.dataFinishChange(ev)}}
                        value={this.state.dtDataFinish}
                                            />    <i onClick={()=>{this.deleteEtapa(s)}} className="material-icons pm-delete-subtask">delete</i>
                                   </div> 
                            </Grid>
                  
                  )
              })}
                         <Grid className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Checkbox style={{color:'#000000'}}  />
                                <input style={{width:'70%'}} onFocus={()=>{this.setState({subTaskNou:''})}} className='pm-task-description-input' type='text' value={this.state.subTaskNou} onChange={(ev)=>{this.setState({subTaskNou:ev.target.value})}}  onBlur={this.insertSubTask}/>
                            </Grid>
                  </Grid>

                  <AlertDialog
                                            open={this.state.isOpenAlert}
                                            dialogClose={()=>{this.setState({isOpenAlert:false})}}
                                            title={this.props.dictionary.alertDate.subTask}
                                            limba={this.props.dictionary}
                                            yesFunction = {()=>{this.setState({isOpenAlert:false})}}
                                            noButtonDisplay = {1}
                    /> 

         </div>
        );
       }
}//end class


SubTaskuriList.propType = {
    objInfoTask:PropTypes.object,
    getData:PropTypes.func,
    listSubTaskuri:PropTypes.array,
    dictionary:PropTypes.object,
    dataStart:PropTypes.string,
    dataFinish:PropTypes.string,
    dtDataStart:PropTypes.string,
    dtDataFinish:PropTypes.string,
    isUserView:PropTypes.bool,
    
}